import { ApiError, authGet, authGetWithMeta, authPatch } from '../http_client.js';
import { ConfigHashStore } from '../../config_sync/config_hash_store.js';
import { PrimedResponses } from '../primed_responses.js';
import type { PlayerDto, UpdatePlayerRequest, LeaderboardProfileDto } from '../dto/player.dto.js';

export async function getPlayer(): Promise<PlayerDto>
{
  return authGet<PlayerDto>( 'api/player/me' );
}

export async function getLeaderboardProfile( playerId: number ): Promise<LeaderboardProfileDto>
{
  return authGet<LeaderboardProfileDto>( `api/player/${playerId}/leaderboard-profile` );
}

export async function updatePlayer( payload: UpdatePlayerRequest ): Promise<PlayerDto>
{
  return authPatch<PlayerDto>( 'api/player/me', payload );
}

export async function getMyConfigs(): Promise<Record<string, unknown>>
{
  return authGet<Record<string, unknown>>( 'api/player/me/configs' );
}

export async function getContentConfig<T>( type: string ): Promise<T>
{
  const primed = PrimedResponses.take<{ data: T; hash: string | null }>( `content_config:${type}` );
  if ( primed )
  {
    if ( primed.hash ) ConfigHashStore.set( type, primed.hash );
    else ConfigHashStore.remove( type );
    return primed.data;
  }

  try
  {
    const { data, etag } = await authGetWithMeta<T>( `api/player/me/content-config/${type}` );
    const hash = ConfigHashStore.normalizeEtag( etag );
    if ( hash ) ConfigHashStore.set( type, hash );
    else ConfigHashStore.remove( type );
    return data;
  }
  catch ( e )
  {
    if ( e instanceof ApiError && e.status === 404 ) ConfigHashStore.remove( type );
    throw e;
  }
}

export interface ConfigHashesResponse
{
  hashes: Record<string, string>;
  generated_at: string;
}

export function getConfigHashes(): Promise<ConfigHashesResponse>
{
  const primed = PrimedResponses.take<ConfigHashesResponse>( 'config_hashes' );
  if ( primed ) return Promise.resolve( primed );
  return authGet<ConfigHashesResponse>( 'api/player/me/config-hashes' );
}


